/**
 * Pure decision for the auto-expand effect on /analysis. Returns true when
 * the right panel should be force-opened: an analysis is in flight, or there
 * is a stored result to show (identified by id). Extracted so the rule can
 * be unit-tested without rendering the page.
 */
export function shouldAutoExpandPanel(args: {
  isAnalyzing: boolean;
  analysisId: string | null | undefined;
}): boolean {
  return args.isAnalyzing || !!args.analysisId;
}
